// extracted by mini-css-extract-plugin
module.exports = {"layout":"impact-card_layout__7Rtl8","figure":"impact-card_figure__Ckjo2","label":"impact-card_label__6LAZW"};